/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_FAV } from "./actionTypes"
import { apiError, addFavSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addFav } from "../../../helpers/backend_helper"

function* add(request) {
  try {
    const response = yield call(addFav, request.payload.idCourse)
    if (response == undefined) throw new Error("API error")
    yield put(addFavSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* favAddSaga() {
  yield takeEvery(ADD_FAV, add)
}

export default favAddSaga
